var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-nav-single-row",class:_vm.layoutClasses},[_vm._l((_vm.navItems),function(item){return [_c(item.contentType,_vm._b({key:item.id,tag:"component",staticClass:"c-nav-single-row__item"},'component',item.data,false))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }